import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { heroData } from '../../data/heroData';
import './IntroScreen.css';

const INTRO_DURATION_MS = 5200;

const IntroScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('name');

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('slogan'), 800);
    const t2 = setTimeout(() => setPhase('dots'), 1600);
    const t3 = setTimeout(() => setPhase('hold'), 3800);
    const t4 = setTimeout(() => setPhase('reveal'), 4000);
    const t5 = setTimeout(() => onComplete?.(), INTRO_DURATION_MS);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(t5);
    };
  }, [onComplete]);

  const name = heroData.content.name;
  const slogan = heroData.content.introTagline;

  return (
    <div className="intro-screen">
        {/* Left panel - slides left */}
        <motion.div
          className="intro-panel intro-panel-left"
          initial={{ x: 0 }}
          animate={{ x: phase === 'reveal' ? '-100%' : 0 }}
          transition={{
            duration: 0.9,
            ease: [0.65, 0, 0.35, 1]
          }}
        />
        {/* Right panel - slides right */}
        <motion.div
          className="intro-panel intro-panel-right"
          initial={{ x: 0 }}
          animate={{ x: phase === 'reveal' ? '100%' : 0 }}
          transition={{
            duration: 0.9,
            ease: [0.65, 0, 0.35, 1]
          }}
        />

        {/* Center content */}
        <div className="intro-content">
          <motion.h1
            className="intro-name"
            initial={{ opacity: 0, scale: 0.88, filter: 'blur(10px)' }}
            animate={{
              opacity: phase === 'reveal' ? 0 : 1,
              scale: 1,
              filter: 'blur(0px)'
            }}
            transition={{
              opacity: { duration: phase === 'reveal' ? 0.35 : 0.7 },
              scale: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
              filter: { duration: 0.6 }
            }}
          >
            {name}
          </motion.h1>
          <motion.p
            className="intro-slogan"
            initial={{ opacity: 0, y: 20, filter: 'blur(6px)' }}
            animate={{
              opacity: phase === 'reveal' ? 0 : phase === 'slogan' || phase === 'dots' || phase === 'hold' ? 1 : 0,
              y: phase === 'slogan' || phase === 'dots' || phase === 'hold' ? 0 : 20,
              filter: 'blur(0px)'
            }}
            transition={{
              opacity: { duration: phase === 'reveal' ? 0.3 : 0.5, delay: phase === 'reveal' ? 0 : 0.35 },
              y: { duration: 0.5, delay: 0.35, ease: [0.22, 1, 0.36, 1] },
              filter: { duration: 0.4 }
            }}
          >
            {slogan}
          </motion.p>
          {/* Animated dots - gives users time to read name + slogan */}
          <motion.div
            className="intro-dots"
            initial={{ opacity: 0 }}
            animate={{
              opacity: phase === 'dots' || phase === 'hold' ? 1 : 0
            }}
            transition={{ duration: 0.4 }}
          >
            {[0, 1, 2].map((i) => (
              <motion.span
                key={i}
                className="intro-dot"
                animate={{
                  y: phase === 'dots' || phase === 'hold' ? [0, -8, 0] : 0,
                  opacity: phase === 'dots' || phase === 'hold' ? [0.5, 1, 0.5] : 0.5
                }}
                transition={{
                  duration: 0.6,
                  repeat: phase === 'dots' || phase === 'hold' ? Infinity : 0,
                  delay: i * 0.15,
                  ease: 'easeInOut'
                }}
              />
            ))}
          </motion.div>
        </div>
    </div>
  );
};

export default IntroScreen;
